import { m } from "@recobra/i18n/messages";
import {
  type DocumentFailureReason,
  MAX_VIDEO_ANALYSIS_DURATION_SECONDS,
} from "@recobra/schemas/document";

export const getDocumentFailureDescription = (
  failureReason: DocumentFailureReason | undefined,
): string => {
  if (failureReason === "video_duration_exceeded") {
    return m.doc_video_duration_exceeded({
      maxMinutes: MAX_VIDEO_ANALYSIS_DURATION_SECONDS / 60,
    });
  }

  return m.doc_failed_description();
};
